import {BaseAppModel} from "./AppModel";
import Category from "@/model/Category";
import ProductConfig from "@/model/ProductConfig";
import {noImg} from "@/asset/img";
import Company from "@/model/Company";
import {NetConfigMode} from "@/module/device/NetConfigMode";

export default class Product extends BaseAppModel<Product> {
    name!: string
    key!: string
    natureKey!: string
    description!: string
    secret!: string
    icon = noImg
    netConfigMode = NetConfigMode.SMART_CONFIG

    category = new Category()
    config = new ProductConfig()
    company?: Company= new Company()
}
